module.exports = __webpack_public_path__ + "static/DPLLogo-248x165.6b113574.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DPLLogo/DPLLogo-248x165.png
// module id = 439
// module chunks = 35783957827783